export enum PollingStatus {
  POLLING = 'Polling',
  DONE = 'Done',
  ERROR = 'Error'
}

/**
 * Distinguishes a panel-supplier / infrastructure feasibility failure from a
 * genuine "audience is infeasible" verdict. Both come back as isFeasible=false /
 * feasibility=0, so those fields can't tell them apart.
 *
 * pollingStatus=Error is the discriminator: the backend sets it only on a
 * failure — never on a real feasibility verdict, which is always Done — across
 * every supplier path (PureSpectrum in services/costAndFeasibilityV2, and Cint
 * V1 via CintManagerOps.makeFeasibilityWithPollingError). It is fully
 * backend-controlled, so unlike sniffing errors[].field it can't be spoofed by
 * a third party: on the Cint V1 path the error `field` is passed through
 * verbatim from Cint's external API, so no field value is a reliable,
 * supplier-agnostic marker.
 *
 * NB: this depends on the backend emitting pollingStatus=Error for PureSpectrum
 * failures (cin-questionnaire#1244) — deploy that first, or PS errors keep
 * reading as "infeasible" until it lands.
 */
export const isFeasibilitySupplierError = (
  estimate?: { pollingStatus?: string | null } | null
): boolean => estimate?.pollingStatus === PollingStatus.ERROR
